import React from "react";
import classnames from "classnames";
import { BUTTON_HEIGHT_REGULAR, getShimmerClass } from "utils/constants/ui";

const PricingTableLoader = ({ withShimmer }) => {
  const shimmerClass = getShimmerClass(withShimmer);

  return (
    <div className="flex flex-row mt5">
      {new Array(3).fill("").map((_, stubIx) => (
        <div
          key={stubIx}
          className={classnames("w-100 flex flex-column items-center", {
            mh3: stubIx === 1
          })}
        >
          <div className={`${shimmerClass} h3 w-50`} />
          <div className={`${shimmerClass} h2 w-90 mt3`} />
          <div className={`${shimmerClass} h2 w-30 mt2`} />
          <div className={`${shimmerClass} h2 w-80 mt2`} />
          <div className={`${shimmerClass} h2 w-60 mt2`} />
          <div
            style={{ height: BUTTON_HEIGHT_REGULAR }}
            className={`${shimmerClass} w-20 mt3 br2`}
          />
        </div>
      ))}
    </div>
  );
};

export default PricingTableLoader;
